export default "__VITE_ASSET__CgJO7Ss$__"